import {Grid, Tab, Tabs, Typography} from '@mui/material'
import {useEffect, useState} from "react";

export const useTabsEspecificaciones = ({items = []}) => {
    const [escogido, setEscogido] = useState('')

    const cambio = (value) => {

        setEscogido(value)

    }

    const obtenerEscogido = (nombre) => {

        if (!escogido) return ''
        let index = items.findIndex(e => e.nombre === nombre)

        if (index > -1) {
            return items[index].descripcion
        } else {
            return ''
        }


    }


    const TabsEspecificaciones = () => {

        return (
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Tabs value={escogido} onChange={(e, value) => cambio(value)} aria-label="basic tabs example">
                        {items.map(item => (
                            <Tab value={item.nombre} label={item.nombre}/>
                        ))}

                    </Tabs>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                    <Typography sx={{fontSize: 14}}>
                        {obtenerEscogido(escogido)}
                    </Typography>
                </Grid>


            </Grid>


        )
    }

    useEffect(() => {

        if (items.length > 0) {
            setEscogido(items[0].nombre)
        }

    }, [items])
    return {
        TabsEspecificaciones
    }
}